/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import LinkExternalIcon from '@atlaskit/icon/core/link-external';
import { GoalsIcon } from '@atlaskit/logo';

import { LinkMenuItem } from '@atlaskit/side-nav-items/link-menu-item';
import { useIntl, defineMessage } from '@atlassian/jira-intl';
import type { AppProps } from '../types.tsx';

const goals = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.goals.goals',
	// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
	defaultMessage: 'Goals',
	description: 'Label for Goals app shortcut button',
});

export function Goals({ onClick }: AppProps): React.JSX.Element {
	const { formatMessage } = useIntl();
	const url = 'https://home.atlassian.com/goals';

	return (
		<LinkMenuItem
			href={url}
			elemAfter={<LinkExternalIcon label="" spacing="spacious" size="small" />}
			elemBefore={<GoalsIcon shouldUseNewLogoDesign size="xsmall" />}
			target="_blank"
			onClick={onClick}
			// eslint-disable-next-line jira/integration/test-id-by-folder-structure
			testId="navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.ui.goals.menu-link-item"
		>
			{formatMessage(goals)}
		</LinkMenuItem>
	);
}
